import type { ApolloClient } from '@apollo/client';
import { useApolloClient } from '@apollo/client';

import type { AppApolloClient } from '../types/common-models';

export const useAppApolloClient = useApolloClient as (
  override?: ApolloClient<object>,
) => AppApolloClient;
